import React, { ReactElement, useEffect, useRef, useState } from "react";
import { useDispatch, useSelector } from "react-redux";
import BtnInformacao from "../../components/BtnInformacao";

import ToastAlert from "../../components/toast";
import { TextsProps } from "../../database/txt.interface";
import {
	PacientesProps,
	UserProps,
} from "../../interfaces/pacientes.interface";
import { AvaliationActions } from "../../store/ducks/avaliation";
import { DashBoardActions } from "../../store/ducks/dashboard";
import { PacAvalActions } from "../../store/ducks/manage_pac_aval";
import { AppActions } from "../../store/ducks/app";

import * as Sentry from "@sentry/react";

import {
	TypesBtnInfo,
	TypesErrorRequest,
	TypesMenuInfoProps,
	TypesQuestionnaire,
	TypesQuestionnaireAnamneseTipo,
} from "../../utils/types";

import Questionario_progress from "./Questionario_progress";
import {
	ContainerGoBack,
	ContainerInfoPatient,
	Conteiner,
	Content,
	ContentType,
	HeaderContent,
	PageName,
	Title,
	Image,
	ContainerImage,
	PatientName,
	ContainerTags,
	Tag,
	TagName,
	ContainerDot,
	ContainerInfoEvaluator,
	InfoEvaluator,
	ShowInfo,
	ContainerOptions,
	Option,
	TextOption,
	ContainerOptionsButtonsQuestionari,
	ButtonOptionQuetionary,
	TitleButton,
	ContainerOptionCard,
	CardOption,
	ContaierInfos,
	Novely,
	ContainerSuggestedConduct,
	ContainerIndicators,
	ContainerSugestion,
	HeaderSugestion,
	ContentSugestion,
	Bullet,
	TitleLegend,
	Legend,
	DropdownSelect,
	DropdownOption,
} from "./styles";
import EditUser from "../../assets/icons/editUser.svg";
import DeletUser from "../../assets/icons/deletUser.svg";
import { ReactComponent as ArrowBack } from "../../assets/kinologyIcons/svg/arrow_back.svg";
import { ReactComponent as UserWithoutPhoto } from "../../assets/kinologyIcons/svg/patient.svg";
import { ReactComponent as Dot3 } from "../../assets/kinologyIcons/svg/dotthree.svg";
import { ReactComponent as Prancheta } from "../../assets/kinologyIcons/svg/prancheta.svg";
import { ReactComponent as Cardiology } from "../../assets/kinologyIcons/svg/cardiology.svg";
import { ReactComponent as HomeHealth } from "../../assets/kinologyIcons/svg/HomeHealth.svg";
import { ReactComponent as Man } from "../../assets/kinologyIcons/svg/man.svg";
import { ReactComponent as Hand } from "../../assets/kinologyIcons/svg/hand.svg";
import { ReactComponent as Note } from "../../assets/kinologyIcons/svg/Edit_note.svg";
import { ReactComponent as Arrow } from "../../assets/kinologyIcons/svg/arrow_forward_ios.svg";
import { ReactComponent as Chart } from "../../assets/kinologyIcons/svg/Chart.svg";
import { ReactComponent as Search } from "../../assets/kinologyIcons/svg/SearchPlan.svg";
import { ReactComponent as EditAnote } from "../../assets/kinologyIcons/svg/Edit_note.svg";
import { ReactComponent as ArrowSelect } from "../../assets/kinologyIcons/svg/ArrowSelect.svg";
import { ReactComponent as IndicadorContaA } from "../../assets/kinologyIcons/svg/IndicadorContraA.svg";
import { ReactComponent as IndicadorContaB } from "../../assets/kinologyIcons/svg/IndicadorContraB.svg";
import { ReactComponent as IndicadorContaM } from "../../assets/kinologyIcons/svg/IndicadorContraM.svg";

import { ReactComponent as Indicador1 } from "../../assets/kinologyIcons/svg/Indicador1.svg";
import { ReactComponent as Indicador2 } from "../../assets/kinologyIcons/svg/Indicador2.svg";
import { ReactComponent as Indicador3 } from "../../assets/kinologyIcons/svg/Indicador3.svg";

import ReturnIcon from "../../assets/icons/back_page.svg";
import { ManageProtocolActions } from "../../store/ducks/manage_protocols";
import { AmplitudeLog } from "../../utils/amplitude";
import { Colors } from "../../styles/colors";
import { getEtiquetas } from "../../utils/etiquetas";
import { title } from "process";
import Popup from "../../components/PopupComponent";
import Relatorios from "../Relatorios";
import { ContainerDash, Icon, Return } from "../../styles/global";
import { P3Desk } from "../../styles/styles_text";
import { AnamneseActions } from "../../store/ducks/anamnese";
import ModalSatisfactionReport from "../../components/Modais/ModalSatisfactionReport";
import { RelatorioActions } from "../../store/ducks/relatorios";
import { getPainQuestionnaire } from "../../services/painQuestionnaire";
import { ServicosProps } from "../../interfaces/config.interface";
import { TypesAvaliacoesDynalabs } from "../DashDyanalabs/Dashboard";
import {
	CalcAlteracoesEncontradas,
	CalcAntagonicos,
	CalcCompValoresReferencia,
	CalcContralaterais,
} from "../DashDyanalabs/Funcs";
import { recomendacoesProps } from "../../store/ducks/Models";

enum typeSelected {
	information = "informacoes",
	superiors = "superiores",
	protocols = "protocolos",
	avaliacoes = "avaliações",
	resultados = "resultados",
}
interface QuestionaryOptionsProps {
	title: string;
	icon: ReactElement;
	novely: boolean;
	action: () => void;
}
interface CardOptionsProps extends Partial<QuestionaryOptionsProps> {
	subtitle: string;
	type: string;
}
type RenderComponentsType = {
	avaliações: React.FC;
	resultados: React.FC;
	informacoes?: React.FC;
	superiores?: React.FC;
	protocolos?: React.FC;
};

interface sugestionProps {
	fill: string;
	name_risco: string;
	usuarios: {
		resultado: string;
		user: string;
		user_nome: string;
		exercicio_resultado: string;
	}[];
	valor_risco: number;
	key?: string;
}
interface conductSugestionProps {
	changesFound: null | undefined | sugestionProps;
	contralateralIndicators: null | undefined | sugestionProps;
	antagonisticIndicators: null | undefined | sugestionProps;
	changesReferenceValues: null | undefined | sugestionProps;
}

const Paciente: React.FC = () => {
	const dispatch = useDispatch();
	const botaoRef = useRef<HTMLButtonElement>(null);
	const painQuestionnaireRequest = useRef<AbortController | null>(null);
	const current_language: TextsProps = useSelector(
		(state: any) => state.configs.current_language
	);

	const OptionSelected = useSelector(
		(state: any) => state.app.set_selected_options_page_pattient
	);

	const pacientes = useSelector((state: any) => state.dashboard.pacientes);

	const patients_most_accessed = useSelector(
		(state: any) => state.dashboard.pacientes_mais_visitados.LISTA
	);

	const paciente: PacientesProps = useSelector(
		(state: any) => state.app.is_open_paciente
	);
	const pacientes_loading = useSelector(
		(state: any) => state.dashboard.pacientes_loading
	);

	const historicos_questionarios = useSelector(
		(state: any) => state.pac_aval.perfil_anamnese_array
	);
	const user_logado: UserProps = useSelector((state: any) => state.auth.user);
	const language = useSelector((state: any) => state.configs.language);

	const etis = useSelector((state: any) => state.dashboard.etiquetas);
	const lista_filtro = useSelector((state: any) => state.app.lista_filtro);
	const assimetrias_dynalabs: any = useSelector(
		(state: any) => state.dashboard.assimetrias_dynalabs
	);
	const recomendacao_conduta: recomendacoesProps = useSelector(
		(state: any) => state.dashboard.data_recomendacao_conduta
	);

	const avaliacoes_dynalabs: TypesAvaliacoesDynalabs = useSelector(
		(state: any) => state.dashboard.avaliacoes_dynalabs
	);
	const [current_patient, set_current_patient]: any = useState(null);
	const [popup, setPopup] = useState(false);
	const [dropDownVisible, setDropDownVisible] = useState(false);
	const [recommendedSuggestion, setRecommendedSuggestion] = useState("");
	const [dropDownOptions, setDropDownOptions] = useState<string[]>([
		"Sem orientação",
		"Atividade física externa",
		"Atividade física moderada",
		"Reabilitação interna",
	]);
	const [conductSuggestionData, setConductSuggestionData] =
		useState<conductSugestionProps>({
			changesFound: null,
			contralateralIndicators: null,
			antagonisticIndicators: null,
			changesReferenceValues: null,
		});

	const avaliadores = useSelector((state: any) => state.dashboard.avaliadores);

	const data_last_emission_report = useSelector(
		(state: any) => state.relatorios.last_issued_report
	);
	const cargos_dynalabs = useSelector((state: any) => state.dashboard.cargos);
	const config_servicos: ServicosProps = useSelector(
		(state: any) => state.configs.config_servicos
	);
	const avaliador = avaliadores.filter(
		(item: PacientesProps) =>
			item?.ID_USUARIO === pacientes?.[0]?.USUARIO_AVALIADOR
	)[0];
	/**
	 *
	 * @returns Retorna os dados atualizados do paciente esteja ele na lista principal ou lista dos mais acessados
	 */
	function GetPatientInOrigin() {
		const patient_is_on_the_main_list = pacientes?.filter(
			(item: PacientesProps) => item?.ID_USUARIO == paciente?.ID_USUARIO
		);
		let patient_is_on_the_most_accessed_list = undefined;
		if (patients_most_accessed) {
			patient_is_on_the_most_accessed_list = patients_most_accessed.filter(
				(item: PacientesProps) => item?.ID_USUARIO == paciente?.ID_USUARIO
			);
		}
		const current: PacientesProps =
			patient_is_on_the_main_list[0] != undefined
				? patient_is_on_the_main_list[0]
				: patient_is_on_the_most_accessed_list[0];
		set_current_patient(current);
	}

	useEffect(() => {
		dispatch(RelatorioActions.sync_last_report_emission());
		dispatch(DashBoardActions.set_request_recomendacoes(paciente?.ID_USUARIO));
	}, []);

	useEffect(() => {
		if (data_last_emission_report?.ID_LOG_RELATORIO != undefined) {
			dispatch(
				DashBoardActions.set_questionario_satisfacao_verificar(
					data_last_emission_report?.ID_LOG_RELATORIO,
					"RELATORIO_UNIFICADO"
				)
			);
		}
	}, [data_last_emission_report]);

	type keySuggestion = {
		[key: string]: string;
	};
	const suggestionsObject: keySuggestion = {
		"Sem alterações": "Sem orientação",
		"Alterações leves": "Atividade física externa",
		"Alterações significativas": "Atividade física monitorada",
		"Alterações graves": "Reabilitação interna",
	};

	useEffect(() => {
		GetPatientInOrigin();
	}, [pacientes_loading, pacientes, patients_most_accessed, current_patient]);
	useEffect(() => {
		const changesFound = CalcAlteracoesEncontradas(
			assimetrias_dynalabs,
			{},
			paciente?.ID_USUARIO
		);
		const contralateralIndicators = CalcContralaterais(
			assimetrias_dynalabs,
			{},
			paciente?.ID_USUARIO
		);
		const antagonisticIndicators = CalcAntagonicos(
			assimetrias_dynalabs,
			{},
			paciente?.ID_USUARIO
		);
		const changesReferenceValues = CalcCompValoresReferencia(
			avaliacoes_dynalabs,
			{},
			paciente?.ID_USUARIO
		);

		const nameRiscCurrentChangeFound = changesFound?.find(
			(obj) => obj.usuarios.length > 0
		)?.name_risco;

		setConductSuggestionData({
			changesFound:
				changesFound?.find((obj) => obj.usuarios.length > 0) ?? null,
			contralateralIndicators:
				contralateralIndicators?.find((obj) => obj.usuarios.length > 0) ?? null,
			antagonisticIndicators:
				antagonisticIndicators?.find((obj) => obj.usuarios.length > 0) ?? null,
			changesReferenceValues:
				changesReferenceValues?.find((obj) => obj.usuarios.length > 0) ?? null,
		});

		const suggestionsArray = Object.entries(suggestionsObject);

		if (recomendacao_conduta) {
			const part1 =
				suggestionsArray?.[
					Number(recomendacao_conduta?.RECOMENDACAO_VALOR?.[0])
				]?.[1];
			const part2 =
				suggestionsArray?.[
					Number(recomendacao_conduta?.RECOMENDACAO_VALOR?.[0])
				]?.[0] == nameRiscCurrentChangeFound
					? " (Recomendado)"
					: "";
			const frase = part1 + part2;

			setRecommendedSuggestion(frase);
		} else {
			setRecommendedSuggestion(
				suggestionsObject[nameRiscCurrentChangeFound ?? "Sem alterações"] +
					(nameRiscCurrentChangeFound ? " (Recomendado)" : "")
			);
			const indexSuggestion = suggestionsArray.findIndex(
				(arr) => arr[0] == nameRiscCurrentChangeFound
			);
			if (String(indexSuggestion) != "-1") {
				dispatch(
					DashBoardActions.set_sugestao_conduta_result(String(indexSuggestion))
				);
			}
		}

		const optionsSuggestions = [
			"Sem orientação",
			"Atividade física externa",
			"Atividade física monitorada",
			"Reabilitação interna",
		];
		const updatedOptions = optionsSuggestions.map((option) => {
			const currentSuggestion =
				suggestionsObject[nameRiscCurrentChangeFound ?? "Sem alterações"];

			return option === currentSuggestion
				? option + (nameRiscCurrentChangeFound ? " (Recomendado)" : "")
				: option;
		});

		setDropDownOptions(updatedOptions);
	}, [paciente, recomendacao_conduta]);

	useEffect(() => {
		const dataForAmplitude: Partial<PacientesProps> = {
			ID_USUARIO: current_patient?.ID_USUARIO,
			USUARIO_ATUALIZADO: current_patient?.USUARIO_ATUALIZADO,
			USUARIO_AVALIADOR: current_patient?.USUARIO_AVALIADOR,
			USUARIO_CONDICIONAMENTO: current_patient?.USUARIO_CONDICIONAMENTO,
			USUARIO_CRIADO: current_patient?.USUARIO_CRIADO,
			USUARIO_NOME: current_patient?.USUARIO_NOME,
			USUARIO_SEXO: current_patient?.USUARIO_SEXO,
			USUARIO_RESPONSAVEL: current_patient?.USUARIO_RESPONSAVEL,
		};
		if (OptionSelected === typeSelected.information) {
			setTimeout(() => {
				AmplitudeLog("info_pacientes");
			}, 200);
		}
		if (OptionSelected === typeSelected.protocols) {
			AmplitudeLog("executar_protocolo", {
				body: dataForAmplitude,
			});
		}
		if (OptionSelected === typeSelected.superiors) {
			AmplitudeLog("executar_exercicio", {
				body: dataForAmplitude,
			});
		}
	}, [OptionSelected]);

	const handleActiveClick = (active: string) => {
		dispatch(AppActions.set_selected_options_page_patients(active));
		dispatch(DashBoardActions.set_select_info(TypesMenuInfoProps.BTN_MENU));
		dispatch(ManageProtocolActions.set_button_goback(false));
	};

	const questionario = useSelector((state: any) => state.pac_aval.questionario);

	const handlePacienteEditar = (current_patient: any) => {
		// dispatch(AppActions.set_modal_editar_paciente(true));
		dispatch(AppActions.set_open_paciente(current_patient));
		dispatch(DashBoardActions.set_current_page("informacoes_paciente"));
	};

	const handleOpenExcluir = (current_patient: any) => {
		const obj = {
			mode: "paciente",
			id: current_patient,
		};

		dispatch(AppActions.set_modal_excluir({ status: true, parameter: obj }));
	};

	useEffect(() => {
		dispatch(DashBoardActions.execucoes_request(false));
		dispatch(DashBoardActions.assimetria_request());
		dispatch(DashBoardActions.anamneses_request());

		dispatch(DashBoardActions.sync_porta_entrada_request());
		dispatch(DashBoardActions.gerencias_request());
		dispatch(DashBoardActions.cargos_request());

		dispatch(AnamneseActions.get_historico_anamnese_request());
		dispatch(AvaliationActions.set_force_option_max(3.6));
		dispatch(AvaliationActions.set_force_option_max_str("3 . 60"));

		dispatch(AvaliationActions.set_force_option_min(3));
		dispatch(AvaliationActions.set_force_option_min_str("3 . 00"));
		dispatch(DashBoardActions.anotacoes_request());
		dispatch(DashBoardActions.exercicios_avaliados_request());
		dispatch(
			AnamneseActions.get_relatorio_anamnese_request({
				ANAMNESE: {
					ID_RESPOSTA: 0,
					RESPOSTA_TIPO: "",
				},
				ANAMNESE_CLINICO: {
					ID_RESPOSTA: 0,
					RESPOSTA_TIPO: "",
				},
			})
		);
	}, []);

	//Faz calulo da idade
	const dataAtual = new Date();
	const anoAtual = dataAtual.getFullYear();
	const anoNascParts = current_patient?.USUARIO_NASCIMENTO?.split("-");

	let diaNasc = null;
	let mesNasc = null;
	let anoNasc = null;
	let idade = null;

	if (anoNascParts) {
		diaNasc = anoNascParts[2];
		mesNasc = anoNascParts[1];
		anoNasc = anoNascParts[0];
		idade = anoAtual - anoNasc;
		const mesAtual = dataAtual.getMonth() + 1;
		if (mesAtual < mesNasc) {
			idade--;
		} else {
			if (mesAtual === mesNasc) {
				if (new Date().getDate() < diaNasc) {
					idade--;
				}
			}
		}
	}

	const is_open_toast = useSelector((state: any) => state.app.is_open_toast);

	useEffect(() => {
		dispatch(DashBoardActions.exercices_request());
		dispatch(DashBoardActions.protocolos_request());
	}, []);

	useEffect(() => {
		AmplitudeLog("perfil_paciente", {
			body: {
				current_patient: current_patient?.ID_USUARIO,
			},
		});
	}, []);

	useEffect(() => {
		dispatch(PacAvalActions.set_questionario(""));
	}, []);

	const select_questionnaire = (quest: string) => {
		if (questionario === TypesQuestionnaire.ANAMNESE) {
			dispatch(PacAvalActions.set_tipo_anamnese(quest));
			dispatch(PacAvalActions.set_questionario_request(true));
		}
		if (questionario === TypesQuestionnaire.ANAMNESE_FISICA) {
			dispatch(PacAvalActions.set_tipo_anamnese(quest));
			dispatch(PacAvalActions.set_questionario_request(true));
			dispatch(
				PacAvalActions.set_questionario(TypesQuestionnaire.ANAMNESE_AVALIACAO)
			);
		}
	};

	const execucoes: any = useSelector((state: any) => state.dashboard.execucoes);

	const formatIMC = (weigth: string, heigth: string) => {
		return (
			parseFloat(weigth) /
			(parseFloat(heigth.replace(",", ".")) *
				parseFloat(heigth.replace(",", ".")))
		).toFixed(2);
	};

	const assimetria = useSelector((state: any) => state.dashboard.assimetria);

	const CALCULO_IQ = assimetria[0]?.CALCULO_IQ || [];

	function openModalShereAnamnese(typeAnamnese: string) {
		if (questionario != "ANAMNESE_FISICA") {
			dispatch(AppActions.set_modal_compartilhamento(true, 10));
			dispatch(AppActions.set_continue_compartilhamento("ShereAnamnese"));
			select_questionnaire(typeAnamnese);
		} else {
			select_questionnaire(typeAnamnese);
		}
	}
	useEffect(() => {
		painQuestionnaireRequest.current?.abort();
		const controller = new AbortController();
		painQuestionnaireRequest.current = controller;
		dispatch(RelatorioActions.setQuestionnairePainEVA([] as any));
		void getPainQuestionnaire(
			user_logado.token,
			paciente?.ID_USUARIO,
			language,
			dispatch,
			controller.signal
		);
		dispatch(DashBoardActions.preensao_palmar_request(paciente?.ID_USUARIO));
		return () => controller.abort();
	}, [dispatch, language, paciente?.ID_USUARIO, user_logado.token]);

	useEffect(() => {
		botaoRef?.current?.focus();
	}, []);

	function GetLastAvaliation() {
		if (execucoes.length > 0) {
			return execucoes[0].EXECUCAO_EXECUTADA.slice(0, 10)
				.replace(/-/g, "/")
				.split("/")
				.reverse()
				.join("/");
		} else {
			return "-";
		}
	}

	function OpenSF36() {
		dispatch(AnamneseActions.set_anamnese_type("SF_36"));
		dispatch(AnamneseActions.set_anamnese_category("SF_36"));

		if (
			historicos_questionarios.length > 0 &&
			historicos_questionarios?.historico_sf_36[0] &&
			historicos_questionarios?.historico_sf_36[0]
				?.QUESTIONARIO_RESPOSTA_CONCLUIDO
		) {
			dispatch(
				AppActions.set_modal_continue_or_to_generate_new_anamnese(
					true,
					TypesQuestionnaire.ANAMNESE
				)
			);
		} else {
			dispatch(AppActions.set_open_modal_escolha_modo(true));
		}
	}

	const Options = [
		{
			title: current_language?.avaliacoes,
			action: () => {
				handleActiveClick(typeSelected.avaliacoes);
			},
		},
		{
			title: current_language?.resultados,
			action: () => {
				handleActiveClick(typeSelected.resultados);
			},
		},
	];
	const QuestionaryOptionsButtons: QuestionaryOptionsProps[] = [
		{
			title: current_language?.anamnese,
			icon: <Prancheta color={Colors?.primary_blue_k_main} />,
			novely: false,
			action: () => {
				dispatch(DashBoardActions.set_current_page("anamnese"));
			},
		},
		{
			title: current_language?.dor,
			icon: <HomeHealth />,
			novely: true,
			action: () => {
				painQuestionnaireRequest.current?.abort();
				const controller = new AbortController();
				painQuestionnaireRequest.current = controller;
				dispatch(RelatorioActions.setQuestionnairePainEVA([] as any));
				void getPainQuestionnaire(
					user_logado.token,
					paciente?.ID_USUARIO,
					language,
					dispatch,
					controller.signal
				);
				dispatch(DashBoardActions.set_current_page("mapa_dor"));
				// dispatch(DashBoardActions.set_current_page("pre_report_eva"))
			},
		},
		{
			title: "SF-36",
			icon: <Cardiology color={Colors?.primary_blue_k_main} />,
			novely: false,
			action: () => {
				OpenSF36();
			},
		},
	];
	const CardOptions: CardOptionsProps[] = [
		{
			type: current_language?.avaliar,
			icon: <Man />,
			title: current_language?.forca_assimetria,
			subtitle: current_language?.avalie_corpo_todo_dinamometro,
			action: () =>
				dispatch(DashBoardActions.set_current_page("protocols_in_patient")),
		},
		// {
		// 	type: current_language?.avaliar,
		// 	icon: <Hand />,
		// 	title: current_language?.prensao_palmar,
		// 	subtitle: current_language?.avalie_prensao_palmar_hand_grip,
		// 	action: () => {},
		// },
		{
			type: current_language?.avaliar,
			icon: <Note />,
			title: current_language?.evolucao_atendiemento,
			subtitle: current_language?.evolucao_atendiemento_descricao,
			action: () =>
				dispatch(DashBoardActions.set_current_page("listagem_anotacoes")),
		},
	];
	const PopupOptions = [
		{
			title: current_language?.editar_paciente,
			action: () => {
				handlePacienteEditar(current_patient);
				AmplitudeLog("editar_paciente");
			},
		},
		{
			title: current_language?.editar_etiquetas,
			action: () => {
				dispatch(AppActions.set_modal_atribuir_etiqueta(true));
			},
		},
		{
			title: current_language?.atribuir_avaliador,
			action: () => {
				dispatch(AppActions.set_lista_pacientes([current_patient?.ID_USUARIO]));
				dispatch(AppActions.set_modal_atribuir_avaliador(true));
			},
		},
		{
			title: current_language?.excluir_paciente,
			action: () => {
				handleOpenExcluir(current_patient);
				AmplitudeLog("excluir_paciente");
			},
		},
	];
	const CardOptionsResults = [
		{
			icon: <Chart />,
			type: current_language?.visualizar_gerar,
			title: current_language?.relatorios_home,
			subtitle: current_language?.consulte_gere_relatorio,
			action: () => dispatch(DashBoardActions.set_current_page("relatorios")),
		},
		{
			icon: <Search />,
			type: current_language?.visualizar,
			title: current_language?.prontuario,
			subtitle: current_language?.informacoes_cadastro,
			action: () => {},
		},
		{
			icon: <EditAnote />,
			type: current_language?.anotar,
			title: current_language?.evolucao_paciente,
			subtitle: current_language?.consulte_anotacoes,
			action: () =>
				dispatch(DashBoardActions.set_current_page("listagem_anotacoes")),
		},
	];

	const LegendOptions = [
		{
			color: Colors.tertiary_green_1_light,
			title: "Sem alterações - Sem orientação",
		},
		{
			color: Colors.tertiary_yellow_1_dark,
			title: "Alterações leves - Atividade física externa",
		},
		{
			color: Colors.tertiary_orange_1_light,
			title: "Alterações significativas - Atividade física monitorada",
		},
		{
			color: Colors.tertirary_red_1_dark,
			title: "Alterações graves - Reabilitação interna",
		},
	];

	type keyIcons = {
		[key: string]: ReactElement;
	};
	const contralateralIndicatorIcon: keyIcons = {
		positivo: <IndicadorContaB />,
		intermediario: <IndicadorContaM />,
		negativo_1: <IndicadorContaA />,
		negativo_2: <IndicadorContaA />,
	};
	const antagonisticIndicatorsIcon: keyIcons = {
		POSITIVO: <Indicador1 />,
		NEGATIVO: <Indicador2 />,
		"S/R": <Indicador3 />,
	};
	const changesReferenceValuesIcon: keyIcons = {
		POSITIVO: <Indicador1 />,
		NEGATIVO: <Indicador2 />,
		"S/R": <Indicador3 />,
	};

	const titleContralateralIndicator: any = {
		positivo: "Baixo risco de lesão",
		intermediario: "Médio risco de lesão",
		negativo_1: "Alto risco de lesão",
		negativo_2: "Alto risco de lesão",
	};
	const titleAntagonisticIndicators: any = {
		"Baixa chance de lesão": "Não há risco de lesão",
		"Há chance de lesão": "Há risco de lesão",
		"Sem valor de refêrencia": "S/ valor de referência",
	};
	const titleChangesReferenceValues: any = {
		"Dentro do esperado": "Dentro do esperado",
		"Abaixo do esperado": "Fora do esperado",
		"Sem valor de refêrencia": "S/ valor de referência",
	};

	//UI
	return (
		<ContainerDash id="DivPrincipal">
			{is_open_toast && <ToastAlert />}
			{questionario === TypesQuestionnaire.ANAMNESE ||
			questionario === TypesQuestionnaire.ANAMNESE_FISICA ? (
				<>
					<ContentType>
						<Title>{current_language?.escolha_anamnese}</Title>
						<div className="btns_type">
							<BtnInformacao
								Icon={TypesBtnInfo.BTN_SAUDE}
								Texto={current_language?.saude}
								funcao={() => {
									openModalShereAnamnese(TypesQuestionnaireAnamneseTipo.SAUDE);
									AmplitudeLog(
										questionario === TypesQuestionnaire.ANAMNESE_FISICA
											? "anamnese_fisica_saude"
											: "anamnese_saude"
									);
								}}
							/>
							<BtnInformacao
								Icon={TypesBtnInfo.BTN_REABILITACAO}
								Texto={current_language?.reabilitacao}
								funcao={() => {
									openModalShereAnamnese(
										TypesQuestionnaireAnamneseTipo.REABILITACAO
									);
									AmplitudeLog(
										questionario === TypesQuestionnaire.ANAMNESE_FISICA
											? "anamnese_fisica_reabilitacao"
											: "anamnese_reabilitacao"
									);
								}}
							/>
							<BtnInformacao
								Icon={TypesBtnInfo.BTN_ESPORTIVA}
								Texto={current_language?.esportiva}
								funcao={() => {
									openModalShereAnamnese(
										TypesQuestionnaireAnamneseTipo.ESPORTIVO
									);
									AmplitudeLog(
										questionario === TypesQuestionnaire.ANAMNESE_FISICA
											? "anamnese_fisica_esportiva"
											: "anamnese_esportiva"
									);
								}}
							/>
							<BtnInformacao
								Icon={TypesBtnInfo.BTN_ESTETICA}
								Texto={current_language?.estetica}
								funcao={() => {
									openModalShereAnamnese(
										TypesQuestionnaireAnamneseTipo.ESTETICO
									);
									AmplitudeLog(
										questionario === TypesQuestionnaire.ANAMNESE_FISICA
											? "anamnese_fisica_estetica"
											: "anamnese_estetica"
									);
								}}
							/>
						</div>
					</ContentType>
				</>
			) : questionario === TypesQuestionnaire.ANAMNESE_TIPO ? (
				<Questionario_progress
					key={TypesQuestionnaire.ANAMNESE}
					Type={TypesQuestionnaire.ANAMNESE}
				/>
			) : questionario === TypesQuestionnaire.ANAMNESE_AVALIACAO ? (
				<Questionario_progress
					key={TypesQuestionnaire.ANAMNESE_AVALIACAO}
					Type={TypesQuestionnaire.ANAMNESE_AVALIACAO}
				/>
			) : questionario === TypesQuestionnaire.SF_36 ? (
				<Questionario_progress
					key={TypesQuestionnaire.SF_36}
					Type={TypesQuestionnaire.SF_36}
				/>
			) : (
				<Content>
					<HeaderContent>
						<Return
							onClick={() =>
								dispatch(DashBoardActions.set_current_page("pacientes"))
							}
						>
							<Icon
								src={ReturnIcon}
								style={{ width: "1rem", height: "1rem" }}
							/>
							<P3Desk style={{ color: Colors?.primary_blue_k_main }}>
								{current_language?.menu_lateral_inicio}
							</P3Desk>
						</Return>
						<ContainerInfoPatient>
							<ContainerImage>
								{current_patient?.USUARIO_FOTO != "" &&
								current_patient?.USUARIO_FOTO != null &&
								current_patient?.USUARIO_FOTO != "img/photo.png" ? (
									<Image src={current_patient?.USUARIO_FOTO} />
								) : (
									<UserWithoutPhoto color={Colors?.white} />
								)}
							</ContainerImage>
							<PatientName>
								{current_patient?.USUARIO_NOME?.length >= 25
									? current_patient?.USUARIO_NOME?.slice(0, 25) + "..."
									: current_patient?.USUARIO_NOME}
							</PatientName>
							<ContainerTags>
								{getEtiquetas(paciente, etis, lista_filtro).map(
									(e: any, index: number) =>
										index <= 2 ? (
											<Tag key={e.ID_ETIQUETA}>
												<TagName>
													{e.ETIQUETA_NOME?.length >= 13 &&
													current_patient?.USUARIO_NOME?.length >= 15 &&
													getEtiquetas(paciente, etis, lista_filtro)?.length > 2
														? e.ETIQUETA_NOME?.slice(0, 13) + "..."
														: e.ETIQUETA_NOME}
												</TagName>
											</Tag>
										) : (
											index === 3 && (
												<Tag key={e.ID_ETIQUETA}>
													<TagName>...</TagName>
												</Tag>
											)
										)
								)}
							</ContainerTags>
							<ContainerDot onClick={() => setPopup(!popup)}></ContainerDot>
							<Popup
								visible={popup}
								options={PopupOptions}
								onPress={() => setPopup(false)}
							/>
						</ContainerInfoPatient>
						<ContainerInfoEvaluator>
							<InfoEvaluator className="mr-2">
								{`${current_language?.pag_inicial_avaliador}: ${
									!!avaliador?.USUARIO_NOME ? avaliador?.USUARIO_NOME : "-"
								}`}
							</InfoEvaluator>
							{config_servicos?.SERVICO_DYNALAB && (
								<>
									<InfoEvaluator className="mr-2">
										Cargo:{" "}
										{cargos_dynalabs?.find(
											(item: any) => item.ID_CARGO == current_patient?.ID_CARGO
										)?.CARGO_TITULO ?? "-"}
									</InfoEvaluator>
									<InfoEvaluator className="mr-2">
										Matrícula:{" "}
										{current_patient?.USUARIO_MATRICULA
											? current_patient?.USUARIO_MATRICULA
											: "-"}
									</InfoEvaluator>
								</>
							)}
							<ShowInfo onClick={() => handlePacienteEditar(current_patient)}>
								{current_language?.ver_informacao}
							</ShowInfo>
						</ContainerInfoEvaluator>
					</HeaderContent>

					<ContainerSuggestedConduct visible={config_servicos?.SERVICO_DYNALAB}>
						<P3Desk
							style={{ color: Colors.primary_blue_k_main, fontWeight: 700 }}
						>
							{`Baseada nas alterações encontradas, selecione uma sugestão de conduta para o(a) paciente ${current_patient?.USUARIO_NOME}:`}
							<div
								style={{
									width: "100%",
									display: "flex",
									marginTop: 10,
									alignItems: "center",
									borderBottomWidth: 1,
									paddingBottom: 5,
									borderBottomColor: "#000E4B33",
									flexDirection: "row",
									cursor: "pointer",
									position: "relative",
								}}
								onClick={() => setDropDownVisible(!dropDownVisible)}
							>
								<div
									style={{ width: "98%", cursor: "pointer", fontWeight: "400" }}
								>
									{conductSuggestionData?.changesFound
										? recommendedSuggestion
										: "Não há dados disponíveis"}
								</div>
								<ArrowSelect />
								<DropdownSelect visible={dropDownVisible}>
									{dropDownOptions.map((item, index) => (
										<DropdownOption
											key={index}
											onClick={() => {
												setRecommendedSuggestion(item);
												dispatch(
													DashBoardActions.set_sugestao_conduta_result(
														String(index)
													)
												);
											}}
										>
											{item}
										</DropdownOption>
									))}
								</DropdownSelect>
							</div>
						</P3Desk>
						<ContainerIndicators>
							<div
								style={{
									width: "25%",
									display: "flex",
									flexDirection: "column",
									// backgroundColor: 'red'
								}}
							>
								<ContainerSugestion width={99}>
									<HeaderSugestion>Alterações encontradas</HeaderSugestion>
									<ContentSugestion
										direction="row"
										fontWeigth={conductSuggestionData?.changesFound ? 400 : 700}
									>
										{conductSuggestionData?.changesFound ? (
											<>
												<Bullet
													bg={conductSuggestionData?.changesFound?.fill}
													style={{ marginBottom: 3 }}
												/>
												{conductSuggestionData?.changesFound?.name_risco}
											</>
										) : (
											"Não há dados disponíveis"
										)}
									</ContentSugestion>
								</ContainerSugestion>

								<ContainerSugestion width={99} marginTop={5}>
									<HeaderSugestion>Exercício</HeaderSugestion>
									<ContentSugestion
										fontWeigth={
											conductSuggestionData?.changesFound?.usuarios?.[0]
												?.exercicio_resultado
												? 400
												: 700
										}
									>
										{conductSuggestionData?.changesFound?.usuarios?.[0]
											?.exercicio_resultado
											? conductSuggestionData?.changesFound?.usuarios?.[0]
													?.exercicio_resultado
											: "Não há dados disponíveis"}
									</ContentSugestion>
								</ContainerSugestion>
							</div>
							<div
								style={{
									width: "75%",
									display: "flex",
									justifyContent: "space-between",
									paddingLeft: 5,
									// backgroundColor: 'blue'
								}}
							>
								<ContainerSugestion width={32}>
									<HeaderSugestion>Indicadores Contralaterais</HeaderSugestion>
									<ContentSugestion
										direction="row"
										fontWeigth={
											conductSuggestionData?.contralateralIndicators ? 400 : 700
										}
										height={Boolean(
											conductSuggestionData?.contralateralIndicators
										)}
									>
										{conductSuggestionData?.contralateralIndicators ? (
											<>
												<Bullet
													bg={
														conductSuggestionData?.contralateralIndicators
															?.key == "negativo_1" ||
														conductSuggestionData?.contralateralIndicators
															?.key == "negativo_2"
															? "#D12600"
															: conductSuggestionData?.contralateralIndicators
																	?.fill
													}
													style={{ marginBottom: 3 }}
												/>
												{
													titleContralateralIndicator[
														conductSuggestionData?.contralateralIndicators?.key!
													]
												}
											</>
										) : (
											"Não há dados disponíveis"
										)}
									</ContentSugestion>
									{conductSuggestionData?.contralateralIndicators?.key &&
										contralateralIndicatorIcon[
											conductSuggestionData?.contralateralIndicators?.key
										]}
								</ContainerSugestion>

								<ContainerSugestion width={32}>
									<HeaderSugestion>Indicadores Antagônicos</HeaderSugestion>
									<ContentSugestion
										direction="row"
										fontWeigth={
											conductSuggestionData?.antagonisticIndicators ? 400 : 700
										}
										height={Boolean(
											conductSuggestionData?.antagonisticIndicators
										)}
									>
										{conductSuggestionData?.antagonisticIndicators ? (
											<>
												<Bullet
													bg={
														conductSuggestionData?.antagonisticIndicators?.fill
													}
													style={{ marginBottom: 3 }}
												/>
												{
													titleAntagonisticIndicators[
														conductSuggestionData?.antagonisticIndicators
															?.name_risco
													]
												}
											</>
										) : (
											<>{"Não há dados disponíveis"}</>
										)}
									</ContentSugestion>
									{conductSuggestionData?.antagonisticIndicators?.usuarios?.[0]
										?.resultado &&
										antagonisticIndicatorsIcon[
											conductSuggestionData?.antagonisticIndicators
												?.usuarios?.[0]?.resultado
										]}
								</ContainerSugestion>

								<ContainerSugestion width={32}>
									<HeaderSugestion>
										Alteração comparado aos valors de ref.
									</HeaderSugestion>
									<ContentSugestion
										direction="row"
										fontWeigth={
											conductSuggestionData?.changesReferenceValues ? 400 : 700
										}
										height={Boolean(
											conductSuggestionData?.changesReferenceValues
										)}
									>
										{conductSuggestionData?.changesReferenceValues ? (
											<>
												<Bullet
													bg={
														conductSuggestionData?.changesReferenceValues?.fill
													}
													style={{ marginBottom: 3 }}
												/>
												{
													titleChangesReferenceValues[
														conductSuggestionData?.changesReferenceValues
															?.name_risco
													]
												}
											</>
										) : (
											<>{"Não há dados disponíveis"}</>
										)}
									</ContentSugestion>
									{conductSuggestionData?.changesReferenceValues &&
										changesReferenceValuesIcon[
											conductSuggestionData?.changesReferenceValues
												?.usuarios?.[0]?.resultado
										]}
								</ContainerSugestion>
							</div>
						</ContainerIndicators>
						<TitleLegend>Sugestões de Conduta</TitleLegend>
						<div
							style={{
								width: "100%",
								display: "flex",
								flexWrap: "wrap",
								flexDirection: "row",
								columnGap: 5,
							}}
						>
							{LegendOptions?.map((item, index) => (
								<Legend key={index}>
									<Bullet bg={item.color} />
									{item.title}
								</Legend>
							))}
						</div>
					</ContainerSuggestedConduct>

					<ContainerOptions>
						{Options?.map(
							(item: { title: string; action: () => void }, index: number) => (
								<Option
									key={index}
									onClick={() => item?.action?.()}
									OptionSelected={OptionSelected}
									title={item?.title}
								>
									<TextOption className="selectTitle">{item?.title}</TextOption>
								</Option>
							)
						)}
					</ContainerOptions>

					{OptionSelected === typeSelected.avaliacoes && (
						<>
							<ContainerOptionsButtonsQuestionari>
								{QuestionaryOptionsButtons?.map((item, index) => (
									<ButtonOptionQuetionary onClick={item.action} key={index}>
										{item?.icon}
										<TitleButton>{item?.title}</TitleButton>
										{item.novely && (
											<Novely>
												{current_language?.perfil_paciente_novo.toUpperCase()}!
											</Novely>
										)}
									</ButtonOptionQuetionary>
								))}
							</ContainerOptionsButtonsQuestionari>
							<ContainerOptionCard>
								{CardOptions?.map((item, index) => (
									<CardOption
										key={index}
										index={index}
										width={50}
										onClick={item.action}
									>
										{item?.icon}
										<ContaierInfos>
											<p className="type">{item?.type}</p>
											<p className="title">{item?.title}</p>
											<p className="subtitle">{item?.subtitle}</p>
										</ContaierInfos>
										<Arrow color={Colors?.neutral_grey_k_20} />
									</CardOption>
								))}
							</ContainerOptionCard>
						</>
					)}
					{OptionSelected === typeSelected.resultados && (
						<div>
							<Relatorios />
						</div>
					)}
				</Content>
			)}
			<ModalSatisfactionReport />
		</ContainerDash>
	);
};

export default Paciente;
